import OrangeCross from 'approot/shared/differentiation/orange-cross';
import { isDifferentiatedAssessmentActivity } from '../logic/is-differentiated-assessment-activity';
import BlackDiamond from './black-diamond';
import { Differentiation } from './differentiation.constants';
import { BlueSquare, GreenCircle, PurpleCircle } from './differentiation.style';

type Props = {
  differentiation: Differentiation;
  number?: number;
  marginRight?: number;
  width?: number;
  height?: number;
  fontSize?: number;
  isSmall?: boolean;
};

const DifferentiationShape = ({
  number,
  differentiation,
  marginRight,
  width,
  height,
  fontSize,
  isSmall,
}: Props) => {
  return (
    <>
      {differentiation === Differentiation.GreenCircle && (
        <GreenCircle
          $fontSize={fontSize}
          $width={width}
          $height={height}
          $marginRight={marginRight}
          data-selector="green-circle"
        >
          {number}
        </GreenCircle>
      )}
      {differentiation === Differentiation.BlueSquare && (
        <BlueSquare
          $fontSize={fontSize}
          $width={width}
          $height={height}
          $marginRight={marginRight}
          $borderRadius={isSmall ? 1 : 4}
          data-selector="blue-square"
        >
          {number}
        </BlueSquare>
      )}
      {differentiation === Differentiation.BlackDiamond && (
        <BlackDiamond
          fontSize={fontSize}
          size={width}
          marginRight={marginRight}
          number={number}
          borderRadius={isSmall ? 1 : 4}
          scale
          data-selector="black-diamond"
        />
      )}
      {differentiation === Differentiation.OrangeCross && (
        <OrangeCross
          fontSize={fontSize}
          size={width}
          marginRight={marginRight}
          number={number}
          data-selector="orange-cross"
        />
      )}

      {isDifferentiatedAssessmentActivity(differentiation) && (
        <PurpleCircle
          $fontSize={fontSize}
          $width={width}
          $height={height}
          $marginRight={marginRight}
          data-selector="purple-circle"
        >
          {number}
        </PurpleCircle>
      )}
    </>
  );
};

export default DifferentiationShape;
